import { Modal } from "../../atoms/DependencyHelper";
// import InputLabel from "../../atoms/Input/InputLabel/InputLabel";
import Image from "../../atoms/image/image";
import styles from "./StockModal.module.scss";
import PropTypes from "prop-types";
import config from "../../../config/index";

const StockModal = (props) => {
	// const [placeHolder, setPlaceHolder] = useState("Your email address");
    const env = config.env;
    const imagePrefix = config.envConfigs[env].imagePrefix;

	return (
		<Modal
			dialogClassName={styles["notify-modal"]}
			show={props.show}
			onHide={props.handleClose}
			animation={false}
		>
			<div>
				<Image
					className={styles["modal-container__close-img"]}
					img_path={`${imagePrefix}/assets/images/close-black.svg`}
					img_width="1.25rem"
					img_height="1.25rem"
					onClick={props.handleClose}
				/>
			</div>
			<div className={styles["modal-container"]}>
				<div className={styles["modal-header"]}>
                <Image
					className={styles["modal-container__tick"]}
					img_path={`${imagePrefix}/assets/images/tick-marks.svg`}

				/>
                	<p className={styles["modal-body__header-text"]}>
                    We’ll get in touch
                    </p>
				</div>
				<div className={styles["modal-body"]}>
					<p className={styles["modal-body__body-text"]}>
                    We’ll let you know as soon as this product is available again.
					</p>
					
				</div>
			</div>
		</Modal>
	);
};

StockModal.propTypes = {
	show: PropTypes.bool,
	handleClose: PropTypes.func,
};

export default StockModal;
